// ─── Lo que la ficha del cliente precarga en un documento nuevo ──────────────
// Al elegir el cliente de un documento nuevo se precargan de su ficha el plazo
// (condiciones de pago), la forma de pago y el asesor comercial.
//
// El campo Cliente busca MIENTRAS se teclea, y por coincidencia parcial: al
// escribir «LA GLORIA VALIENTE SAS», las primeras letras coinciden un instante
// con OTRO cliente, y en ese instante se precargaba lo de esa ficha. Al seguir
// tecleando el cliente se soltaba, pero lo precargado se quedaba pegado. Así
// las cotizaciones a terceros no registrados (GALCO, NUAM) salieron «a 30 días»
// con el plazo de un cliente ajeno.
//
// Ahora la precarga recuerda de QUÉ cliente vino y qué puso. Cuando el cliente
// cambia —o se suelta—, se deshace lo que todavía tenga el valor precargado
// (lo que la persona ya reescribió a mano no se toca) y se aplica el del nuevo.

export const CAMPOS_PRECARGA = ["condiciones_pago", "forma_pago", "asesor_comercial"];

// El texto del plazo, como lo escribe la precarga.
export function textoCondicionesDias(dias) {
  const n = parseInt(dias, 10);
  if (!Number.isFinite(n) || n < 0) return "";
  if (n === 0) return "Contado";
  if (n === 7) return "Una semana (7 días)";
  if (n === 15) return "15 días";
  if (n === 30) return "Un mes (30 días)";
  if (n === 45) return "45 días";
  if (n === 60) return "Dos meses (60 días)";
  if (n === 90) return "Tres meses (90 días)";
  return `${n} días`;
}

// ¿Lo que dice el campo es un plazo que puso la precarga (y no un texto
// propio, como «50% anticipo – 50% entrega»)?
const AUTOGENERADO = /^(Contado|Una semana \(7 días\)|15 días|Un mes \(30 días\)|45 días|Dos meses \(60 días\)|Tres meses \(90 días\)|\d+ días)$/;
export function esPlazoAutogenerado(texto) {
  return AUTOGENERADO.test(String(texto || "").trim());
}

// Deshace la precarga anterior sobre `doc`: cada campo que siga con el valor
// que puso la precarga vuelve al que tenía antes. Devuelve los campos tocados.
export function deshacerPrecarga(doc, previa) {
  const tocados = [];
  if (!doc || !previa) return tocados;
  for (const k of Object.keys(previa.puestos || {})) {
    if ((doc[k] || "") === (previa.puestos[k] || "")) {
      doc[k] = (previa.antes || {})[k] || "";
      tocados.push(k);
    }
  }
  return tocados;
}

// Aplica la precarga de `cliente` sobre `doc` y devuelve el registro de lo que
// puso (para poder deshacerlo). `opts.esConversion`: el documento viene de otro
// y su asesor se hereda, así que un cliente sin asesor no lo borra.
export function aplicarPrecarga(doc, cliente, opts = {}) {
  const antes = {};
  const puestos = {};
  const poner = (k, v) => { antes[k] = doc[k] || ""; doc[k] = v; puestos[k] = v; };

  // Plazo: también el contado (dias_pago = 0). Antes `match.dias_pago` era la
  // condición, y el 0 es falso: un cliente de contado no precargaba nada.
  const texto = textoCondicionesDias(cliente.dias_pago);
  if (texto && cliente.dias_pago !== "" && cliente.dias_pago != null) poner("condiciones_pago", texto);

  if (cliente.forma_pago && !doc.forma_pago) poner("forma_pago", cliente.forma_pago);

  if (cliente.asesor_comercial && !doc.asesor_comercial) poner("asesor_comercial", cliente.asesor_comercial);
  else if (!cliente.asesor_comercial && !opts.esConversion && doc.asesor_comercial) poner("asesor_comercial", "");

  return { de: cliente.id, antes, puestos };
}
